/* Supplement the responsive CSS with Judge.me's real count and image sizes. */
(() => {
  'use strict';

  let widget;
  let changes;
  let sizing;
  let observedPhotos;
  let queued = false;

  function updatePhotoNavigation(gallery, photos) {
    const maxScroll = photos.scrollWidth - photos.clientWidth;
    const position = Math.abs(photos.scrollLeft);
    const overflowing = maxScroll > 1;
    gallery.dataset.camoOverflow = String(overflowing);
    gallery.dataset.camoCanScrollNext = String(maxScroll - position > 1);

    ['previous', 'next'].forEach(direction => {
      let button = gallery.querySelector(`.camo-review-photos-arrow--${direction}`);
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.className = `camo-review-photos-arrow camo-review-photos-arrow--${direction}`;
        button.setAttribute('aria-label', direction === 'previous' ? 'Scroll customer photos left' : 'Scroll customer photos right');
        const icon = document.createElement('span');
        icon.setAttribute('aria-hidden', 'true');
        button.appendChild(icon);
        button.addEventListener('click', event => {
          event.stopPropagation();
          const currentPhotos = gallery.querySelector('.jm-media-grid__container');
          if (!currentPhotos) return;
          const item = currentPhotos.querySelector('.jm-media-grid__item');
          const styles = getComputedStyle(currentPhotos);
          const step = (item?.getBoundingClientRect().width || 88) + (parseFloat(styles.columnGap) || 0);
          const distance = Math.max(step, Math.floor(currentPhotos.clientWidth / step) * step);
          const sign = (direction === 'previous' ? -1 : 1) * (styles.direction === 'rtl' ? -1 : 1);
          currentPhotos.scrollBy({
            left: sign * distance,
            // A fixed external control must respond to every repeated click.
            behavior: 'instant'
          });
          updatePhotoNavigation(gallery, currentPhotos);
        });
        gallery.appendChild(button);
      }
      button.hidden = !overflowing;
      button.disabled = direction === 'previous' ? position <= 1 : maxScroll - position <= 1;
    });
  }

  function refresh() {
    queued = false;
    if (!widget) return;

    const header = widget.querySelector('.jm-review-widget__header');
    const count = widget.querySelector('.jm-average-rating-display > .jm-cluster > .jm-text:last-of-type');
    if (header && count) {
      header.dataset.camoReviewsCount = count.textContent.trim().replace(/^\(|\)$/g, '');
    }

    const preview = widget.querySelector('.jm-review-widget-header__main-content > .jm-media-preview');
    const gallery = preview?.querySelector('.jm-media-grid');
    const photos = gallery?.querySelector('.jm-media-grid__container');
    if (gallery && photos) {
      updatePhotoNavigation(gallery, photos);
      if (photos !== observedPhotos) {
        if (observedPhotos) {
          sizing.unobserve(observedPhotos);
          observedPhotos.removeEventListener('scroll', schedule);
        }
        observedPhotos = photos;
        sizing.observe(photos);
        photos.addEventListener('scroll', schedule, { passive: true });
      }
    }

    // Keep an explicit entry to Judge.me's full lightbox even when every
    // preview fits in the row and its native scrolling arrows disappear.
    if (preview) {
      const nativePhoto = photos?.querySelector('button.jm-media-grid__item');
      let viewAll = preview.querySelector('.camo-review-photos-button');
      if (nativePhoto && !viewAll) {
        viewAll = document.createElement('button');
        viewAll.type = 'button';
        viewAll.className = 'camo-review-photos-button';
        viewAll.textContent = 'View all photos';
        viewAll.setAttribute('aria-label', 'View all customer photos');
        viewAll.addEventListener('click', () => {
          // Resolve the current Vue-rendered button after sorting/pagination.
          preview.querySelector('.jm-media-grid__container button.jm-media-grid__item')?.click();
        });
        preview.appendChild(viewAll);
      }
      if (viewAll) viewAll.hidden = !nativePhoto;
    }

    // Keep native srcsets and request the resolution needed by each thumbnail.
    widget.querySelectorAll('.jm-media-grid__image').forEach(img => {
      const width = Math.ceil(img.getBoundingClientRect().width);
      if (width > 0 && img.getAttribute('sizes') !== `${width}px`) {
        img.setAttribute('sizes', `${width}px`);
      }
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(refresh);
  }

  function connect() {
    const target = document.getElementById('judgeme_product_reviews');
    if (!target || target === widget) return;
    changes?.disconnect();
    sizing?.disconnect();
    observedPhotos?.removeEventListener('scroll', schedule);
    observedPhotos = undefined;
    widget = target;
    changes = new MutationObserver(schedule);
    changes.observe(widget, { childList: true, subtree: true, characterData: true });
    sizing = new ResizeObserver(schedule);
    sizing.observe(widget);
    schedule();
  }

  function start() {
    connect();
    if (!widget) {
      const awaitingWidget = new MutationObserver(() => {
        connect();
        if (widget) awaitingWidget.disconnect();
      });
      awaitingWidget.observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', connect);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
